import Recorder from 'js-audio-recorder';
import IM from './im'
import cloneDeep from "lodash/cloneDeep";

const defaultProcess = {duration: 0, fileSize: 0, vol: 0}

// 防止意外导致录音没有结束
const watchDog = {
  timer: null,
  clear: () => {
    if(watchDog.timer !== null) {
      clearTimeout(watchDog.timer)
      watchDog.timer = null
    }
  },
  set: (valueFunc, cb) => {
    watchDog.timer = setTimeout(() => {
      if(valueFunc()) cb()
      watchDog.timer = null
      console.warn('record audio watchDog: stopped record!')
    }, 70000)
  }
}
let recorder = null

export default {
  state: {
    recordAudio: {
      status: 'stop',
      process: defaultProcess,
      blob: null,
      duration: 0,
      // voiceDisable: false,
    },
  },
  mutations: {
    START_RECORD_AUDIO(state) {
      state.recordAudio = {
        status: 'recording',
        process: defaultProcess,
        blob: null,
        // voiceDisable: false,
      }
    },
    // eslint-disable-next-line no-unused-vars
    SET_RECORD_AUDIO_PROCESS(state, data) {
      state.recordAudio.process = {...data}
    },
    STOP_RECORD_AUDIO(state, blob) {
      state.recordAudio.status = 'stop'
      state.recordAudio.blob = blob
    },
    SET_DURATION(state, time) {
      state.recordAudio.duration = time;
    }
  },
  actions: {
    checkRecordAudioPremission() {
      return Recorder.getPermission().then((res) => {
        return {
          res: res,
          status: 200
        }
      },(error) => {
        return {
          error:error,
          status: 403,
        }
      })
    },
    startRecordAudio({commit}) {
      if(!recorder) {
        recorder = new Recorder({sampleBits: 8, sampleRate: 11025, numChannels: 1});
        recorder.onprogress = data => {
          commit('SET_RECORD_AUDIO_PROCESS', data)
        }
        recorder.onstopplay = () => {
          recorder = null
        }
        recorder.onerror = error => {
          console.error('Error while recording audio: ', error);
        }
      }
      commit('START_RECORD_AUDIO')
      recorder.start()
      // watchDog.set(() =>  {
      //   console.log(state.recordAudio.status === 'recording','--', dispatch);
      // })
      // state.recordAudio.status === 'recording', () => dispatch('stopRecordAudio')
      return {
        status: 200,
        msg: 'success'
      }
    },
    async stopRecordAudio({state, commit}) {
      if(state.recordAudio.status !== 'recording') return
      recorder.stop()
      const blob = recorder.getWAVBlob()
      commit("STOP_RECORD_AUDIO", blob);
      // convertStreams(blob, commit);
    },
    playRecordAudio({dispatch}) {
      dispatch('stopRecordAudio')
      recorder.play()
    },
    // eslint-disable-next-line no-unused-vars
    sendAudioMsg({state, commit, rootState, dispatch}, options) {
      if (!state.recordAudio.blob) {
        throw Error('No recordAudio.blob to send!')
      }
      if (!state.currentSession) {
        throw Error('No currentSessionAccount to send!')
      }
      let unsend = cloneDeep(state.unsendMsgs);
      const to = options.to;
      let reader = new FileReader();
      reader.readAsDataURL(options.blob);
      let unsendItem = {
        type: "audio",
        createtime: options.createtime,
        time: options.createtime,
        custom: JSON.stringify({
          duration: (Math.round(options.duration) > 60 ? 60 : Math.round(options.duration)) * 1000,
          createtime: options.createtime,
        }),
        file: {
          duration: (Math.round(options.duration) > 60 ? 60 : Math.round(options.duration)) * 1000,
          thumbnailUrl: null,
          mp3Url: null,
        },
        unsend: true,
        flow: "out",
        status: "sending",
      }
      reader.onload = (e) => {
        unsendItem.file.mp3Url = e.target.result;
        unsend[to] = unsend[to] ? [...cloneDeep(unsend[to]), unsendItem] : [unsendItem]
        commit('SET_UNSENDMSGS', unsend);
        dispatch('unsendCountdown', {
          unsendInfo: unsendItem,
          to
        })
        IM.getInstance().sendMsg(options, 'audio');
      }
      console.log('sending p2p audio msg');
    },
  }
}
